import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_trend_chart--arrow"] || "myhouse_trend_chart--arrow"} width="7" height="4" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 0l3.5 4L7 0z" fill="#00C763" fillRule="evenodd" /></svg>);